exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3UVG{min-height:48px;padding:12px 64px 12px 16px;font-size:14px;line-height:20px;-webkit-box-shadow:0 5px 13px rgba(0,0,0,.14);box-shadow:0 5px 13px rgba(0,0,0,.14);position:fixed;top:40px;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);margin:0 auto;z-index:99999;background:#fff;min-width:520px}._3DFn{margin-right:8px}._3UVG span{line-height:24px;display:inline-block}._21cf{position:absolute;right:0;top:0;width:48px;height:48px;border-left:1px solid #e6ebf3;text-align:center;padding-top:12px;cursor:pointer}@media(max-width:768px){._3UVG{min-width:90%;padding-left:40px}._3DFn{margin-right:8px;position:absolute;left:8px}._21cf{bottom:0;height:auto}}", ""]);

// exports
exports.locals = {
	"error": "_3UVG",
	"cross": "_3DFn",
	"close-box": "_21cf"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!./checkout/components/async/notificationsuccess/style.css
// module id = MFQs
// module chunks = 1